<template>
  <b-modal
    :id="id"
    :title="trans('bookings')"
    size="lg"
    :ok-title="trans('close')"
    ok-only
  >
    <p>
      {{ trans('microsite_modify_bookings_about') }}
    </p>
    <b-overlay :show="busy">
      <bookings-table
        :organization="organization"
        :bookings="bookings"
        no-tracking
        @update="$emit('update')"
      ></bookings-table>
    </b-overlay>
  </b-modal>
</template>

<script>
  import BookingsTable from './../invoice/ClientInvoiceBookingsTable'

  export default {
    props: {
      id: {
        type: String,
        default: 'admin-bookings-modal',
      },
      organization: Object,
      bookings: Array,
      busy: Boolean,
    },
    components: {
      BookingsTable,
    },
    data() {
      return {
        trans: trans,
      }
    },
    mounted() {
      window.adminBookingsModal = this
    },
  }
</script>